import Common from "./module/common.js";
import ScrollHint from 'scroll-hint';
import applyFocusVisiblePolyfill from 'focus-visible';
/**ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー
 * matchHeight
ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー*/
$(function() {
	$('.matchHeight').matchHeight();
 $('.infoCard').matchHeight();
});

/**ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー
 * inview
ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー*/
jQuery(function($){
var inviewDeferred = $.Deferred();
if ($('#wrapper').hasClass('inview--on')){
inviewDeferred.resolve();
}
inviewDeferred.done(function (){
inview_fadeIn();
inview_fadeInUp();
inview_zoomIn();
});
 function inview_fadeIn() {   
      $('.inview_fadeIn').one('inview', function (event, isInView) {
        $(this).addClass('inview_fadeIn--now');
        if (isInView) {
        $('.inview_fadeIn--now').each(function (i) {
        $(this).delay(i * 150).queue(function () {
        $(this).addClass('animated animate_fadeIn').removeClass('inview_fadeIn--now inview_fadeIn').dequeue();
        });
        });
        }
        });
}
function inview_fadeInUp() {   
      $('.inview_fadeInUp').one('inview', function (event, isInView) {
        $(this).addClass('inview_fadeInUp--now');
        if (isInView) {
        $('.inview_fadeInUp--now').each(function (i) {
        $(this).delay(i * 150).queue(function () {
        $(this).addClass('animated animate_fadeInUp').removeClass('inview_fadeInUp--now inview_fadeInUp').dequeue();
        });
        });
        }
        });
}
function inview_zoomIn() {   
      $('.inview_zoomIn').one('inview', function (event, isInView) {
        $(this).addClass('inview_zoomIn--now');
        if (isInView) {
        $('.inview_zoomIn--now').each(function (i) {
        $(this).delay(i * 20).queue(function () {
        $(this).addClass('animated animate_zoomIn').removeClass('inview_zoomIn--now inview_zoomIn').dequeue();
        });
        });
        }
        });
}
});





/**ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー
 * smartphone tel use
ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー*/
jQuery(function($){
var agent = navigator.userAgent;
if(agent.search(/iPhone/) != -1 || agent.search(/iPad/) != -1 || agent.search(/iPod/) != -1 || agent.search(/Android/) != -1){

$('.tel').each(function() {
var str = $(this).html();
if ($(this).find('img')) {
$(this).html($('<a>').attr('href', 'tel:' + $(this).find('img').attr('alt').replace(/-/g, '')).append(str + '</a>'));
} else {
$(this).html($('<a>').attr('href', 'tel:' + $(this).text().replace(/-/g, '')).append(str + '</a>'));
}
});
}
});

/**ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー
* iconue img nouse
ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー**/
$(document).ready(function(){
$("a:has('img')").addClass('noicon');
});


/**ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー
 * plugin - scrollhint function
ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー*/
window.addEventListener('DOMContentLoaded', function(){
new ScrollHint('.is-style-scrollTable', {
suggestiveShadow: true,
i18n: {scrollable: 'スクロールできます'}
});
});

/**ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー
*user agent change parts
ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー**/
 jQuery(function($){
    var agent = navigator.userAgent;
    if(agent.search(/iPhone/) != -1 || agent.search(/iPad/) != -1 || agent.search(/iPod/) != -1 || agent.search(/Android/) != -1){
     $('.fixedmenu').css("display","flex");
        $('.pagetop').css("display","none");
         $('.fixedside').css("display","none");
    }
});


/**ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー
*plugin - popup function 
fixedmenu's popup'
ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー**/
$(function () {

  jQuery(".popup-calendarBtn").animatedModal({
    animatedIn:  'zoomIn',  //開くとき
    animatedOut: 'bounceOut', //閉じるとき
   animationDuration: '0.3s',
   color: 'rgba(0,0,0,0.8)',
  });
 
});



/********************
* Retinaディスプレイ分岐
********************/
$(function(){
  var retinaCheck = window.devicePixelRatio;
  if(retinaCheck >= 2) { // Retinaディスプレイのときを分岐させている
  $('img.retina').each( function() {
  var retinaimg = $(this).attr('src').replace(/\.(?=(?:png|jpg|jpeg)$)/i, '@2x.');
  $(this).attr('srcset', retinaimg + " 2x");
  });
  }
  });
  
  /**ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー
  * IE11で固定ヘッダーががたつく件を解消（E独自のオプション機能「スムーズスクロール」というのが悪さ）
  ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー**/
  if(navigator.userAgent.match(/MSIE 10/i) || navigator.userAgent.match(/Trident\/7\./) || navigator.userAgent.match(/Edge\/12\./)) {
  $('body').on("mousewheel", function () {
  event.preventDefault();
  var wd = event.wheelDelta;
  var csp = window.pageYOffset;
  window.scrollTo(0, csp - wd);
  });
  }
  /*******************
  * smooth scroll
  ********************/
  
  $('a[href^="#"]').click(function() {
   var headerHight = $("#header").outerHeight();
      var href = $(this).attr("href");
      var target = $(href == "#" || href == "" ? "body" : href);
      var position = target.offset().top - headerHight;
      $("html, body").animate({ scrollTop: position }, 500, "swing");
      //return false;
  });
  
  
  /*******************
  * back_to_top
  ********************/
  $(function() {
  "use strict";
  var $win = $(window),
  $back_to_top = $('.backtotop'),
  showClass = 'backtotop-visible',
  //一番上のスクロールアニメーションの長さ（ミリ秒）
  scroll_top_duration = 700;
  $win.on('load scroll', function() {
  var contactWrapOffsetTop =  document.getElementById('footer').offsetTop,
  thisScrollTop = $(this).scrollTop(),
  scrollBottom = $(window).scrollTop() + $(window).height();
  
  if ( thisScrollTop >500 ) {
  
  $back_to_top.addClass(showClass);
  
  } else {
  $back_to_top.removeClass(showClass);
  }
  });
  
  var clickEventType=((window.ontouchstart!==null)?'click':'touchstart');
  $back_to_top.on(clickEventType, function() {
  var hsize = $('#header').height();//ヘッダーーの高さを取得
  var topposition = $('body,html').offset().top - hsize; //ターゲットの座標からヘッダの高さ分引く
  
  $('body,html').animate({ scrollTop: topposition , }, scroll_top_duration );
  });
  
  });
